export const CHECK_STATE_COUNTRIES = ['us', 'ca', 'au'];
